export const isLoading = (state) => state.loading

export const getSchema = (state) => state.listSchema[state.resourceType]

export const getFilterSchema = (state) => state.filterSchema[state.resourceType]

export const getResourceType = (state) => state.resourceType

export const getPage = (state) => state.config[state.resourceType].page

export const getPerPage = (state) => state.config[state.resourceType].perPage

export const getSortField = (state) => state.config[state.resourceType].sortField

export const getSortOrder = (state) => state.config[state.resourceType].sortOrder

export const getId = (state) => state.id

export const getFilter = (state) => state.filter[state.resourceType]



// WEBPACK FOOTER //
// ./src/store/modules/list/getters.js